{
  "version": 1,
  "asset_id": "c55772b3-597e-4f47-af1a-026a121c7b25",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/c55772b3-597e-4f47-af1a-026a121c7b25/dzien-dobry-video.mp4",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/c55772b3-597e-4f47-af1a-026a121c7b25/dzien-dobry-video.mp4",
  "original_filename": "dzien-dobry-video.mp4",
  "size": 3137822,
  "content_type": "video/mp4",
  "created_at": "2026-09-30T11:50:06Z"
}
